import { PurchaseOrderSliceState } from './duck/types';

export { purchaseOrdersModuleName } from '../common';

export const POStatusTypes = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
  EDITED: 'edited',
});

export const POStatusText = Object.freeze({
  [POStatusTypes.OPEN]: 'Open',
  [POStatusTypes.CLOSED]: 'Closed',
  [POStatusTypes.EDITED]: 'Closed (Edited)',
});

export const cartStatusTypes = Object.freeze({
  REVIEWING: 'Reviewing',
  AVAILABLE: 'Available',
  ERROR: 'Error',
});

export const arnicaApiPdfType = Object.freeze({
  SKU_CARD_PDF: 'get_sku_card_pdf',
  PO_PDF: 'Get_PO_PDF',
  POCKET_ADVENTURE_CERT_PDF: 'Get_Pocket_Adventure_Cert_PDF',
  SCOUT_ADVENTURE_CERT_PDF: 'Get_Scout_Adventure_Cert_PDF',
  POCKET_MB_CERT_PDF: 'Get_Pocket_MB_Cert_PDF',
});

export const arnicaAPIPdfRankValues = {
  TIGER: 8,
  WOLF: 9,
  BEAR: 10,
  LION: 14,
  WEBELOS: 11,
  ARROW: 12,
};

export const initialSliceState: PurchaseOrderSliceState = {
  selectedPurchaseOrderId: null,
  updatePurchaseOrderLoading: false,
};

export const updatePOReasons = Object.freeze({
  CLOSED: 'Closed in To Purchase Tab UI',
  DELETE: 'Deleted from Purchase Order Details',
  EDITED: 'Edited in Purchase Order Details',
});

export const typeFilter = Object.freeze({
  SKU: 'sku',
  PRICES: 'prices',
  NOTES: 'notes',
});

export const groupByFilter = Object.freeze({
  NO_GROUPING: 'noGrouping',
  ITEM_TYPE: 'itemType',
  YOUTH: 'youth',
  SUB_UNIT: 'subUnit',
});
